import { Helmet } from "react-helmet";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageTransition from "@/components/PageTransition";

import CulverHero from "@/components/culver/CulverHero";
import LossCalculator from "@/components/culver/LossCalculator";
import ProofResults from "@/components/culver/ProofResults";
import ProcessSection from "@/components/culver/ProcessSection";
import GuaranteeSection from "@/components/culver/GuaranteeSection";
import FinalCTA from "@/components/culver/FinalCTA";
import StickyMobileCTA from "@/components/culver/StickyMobileCTA";

const Index = () => {
  return (
    <PageTransition>
      <Helmet>
        <title>Culver City SEO | #1 Rankings in 90 Days or Free</title>
        <meta
          name="description"
          content="Culver City's top-rated local SEO agency. We get businesses to page one of Google in 90 days — guaranteed. Free audit, no contracts, real results."
        />
        <link rel="canonical" href="https://losangelesseogroup.com/" />
        <meta property="og:title" content="Culver City SEO Agency | Page One in 90 Days" />
        <meta
          property="og:description"
          content="We get Culver City businesses ranked #1 on Google. Free audit, no long contracts, money-back guarantee."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Los Angeles SEO Services",
            image: "https://losangelesseogroup.com/og-image.png",
            "@id": "https://losangelesseogroup.com/",
            url: "https://losangelesseogroup.com/",
            telephone: "+1-323-784-1577",
            address: {
              "@type": "PostalAddress",
              streetAddress: "10000 Washington Blvd",
              addressLocality: "Culver City",
              addressRegion: "CA",
              postalCode: "90232",
              addressCountry: "US",
            },
            areaServed: ["Culver City", "West Los Angeles", "Santa Monica", "Mar Vista"],
            priceRange: "$$",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.9",
              reviewCount: "127",
            },
          })}
        </script>
      </Helmet>

      <Navbar />

      <main>
        <CulverHero />
        <LossCalculator />
        <ProofResults />
        <ProcessSection />
        <GuaranteeSection />
        <FinalCTA />
      </main>

      <StickyMobileCTA />
      <Footer />
    </PageTransition>
  );
};

export default Index;
